import { queryClient } from "../../store/queryClient";

const RefreshApp = () => {
  queryClient.refetchQueries();
  return null;
};

export default RefreshApp;
